import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import "./SearchResultMobile.css";

const TABS = [
  {
    key: "Rooms",
    label: "Rooms",
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8" />
        <path d="M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4" />
        <path d="M12 4v6" />
        <path d="M2 18h20" />
      </svg>
    )
  },
  {
    key: "Apartments",
    label: "Apartments",
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M10 12h4" />
        <path d="M10 8h4" />
        <path d="M14 21v-3a2 2 0 0 0-4 0v3" />
        <path d="M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2" />
        <path d="M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16" />
      </svg>
    )
  },
  {
    key: "Hotels",
    label: "Hotels",
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M10 22v-6.57" />
        <path d="M12 11h.01" />
        <path d="M14 15.43V22" />
        <path d="M15 16a5 5 0 0 0-6 0" />
        <rect x="4" y="2" width="16" height="20" rx="2" />
      </svg>
    )
  }
];

class SearchResultMobile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: "Rooms",
      searchQuery: "",
      results: [],
      loading: true,
      error: null,
      notFound: false,
      type: "",
      address: "",
      startDate: "",
      endDate: "",
      rooms: "",
      adults: "",
      kids: "",
      category: "",
      lat: "",
      long: ""
    };
  }

  componentDidMount() {
    this.loadSearchParameters();
  }

  loadSearchParameters = () => {
    const params = new URLSearchParams(window.location.search);

    const type = params.get("t") || "Rooms";
    const address = params.get("a") || "";
    const startDate = params.get("s") || "";
    const endDate = params.get("e") || "";
    const rooms = params.get("r") || "";
    const adults = params.get("ad") || "";
    const kids = params.get("k") || "";
    const category = params.get("c") || "";
    const lat = params.get("lat") || "";
    const long = params.get("long") || "";

    this.setState(
      {
        activeTab: type,
        type,
        address,
        startDate,
        endDate,
        rooms,
        adults,
        kids,
        category,
        lat,
        long,
        searchQuery: address || category || ""
      },
      this.fetchSearchData
    );
  };

  handleTabChange = (tab) => {
    if (tab === this.state.activeTab) return;

    this.setState({ activeTab: tab, type: tab }, () => {
      const { address, startDate, endDate, rooms, adults, kids, category, lat, long } = this.state;

      const url =
        `?t=${encodeURIComponent(tab)}` +
        `&a=${encodeURIComponent(address || "")}` +
        `&s=${encodeURIComponent(startDate || "")}` +
        `&e=${encodeURIComponent(endDate || "")}` +
        `&r=${encodeURIComponent(rooms || "")}` +
        `&ad=${encodeURIComponent(adults || "")}` +
        `&k=${encodeURIComponent(kids || "")}` +
        `&c=${encodeURIComponent(category || "")}` +
        `&lat=${encodeURIComponent(lat || "")}` +
        `&long=${encodeURIComponent(long || "")}`;

      window.history.replaceState({}, "", url);
      this.fetchSearchData();
    });
  };

  fetchSearchData = async () => {
    const { type, address, startDate, endDate, rooms, adults, kids, category, lat, long } = this.state;

    this.setState({ loading: true, error: null, notFound: false });

    try {
      const response = await axios.get("/q", {
        params: {
          t: type || "Rooms",
          a: address || "",
          s: startDate || "",
          e: endDate || "",
          r: rooms || "",
          ad: adults || "",
          k: kids || "",
          c: category || "",
          lat: lat || "",
          long: long || ""
        }
      });

      const payload = response && response.data;
      const data = Array.isArray(payload)
        ? payload
        : Array.isArray(payload && payload.data)
        ? payload.data
        : [];

      this.setState({
        results: data,
        loading: false,
        notFound: data.length === 0
      });
    } catch (error) {
      console.error("Search API Error:", error);
      this.setState({
        results: [],
        loading: false,
        notFound: false,
        error: "We encountered a network issue while retrieving your results."
      });
    }
  };

  handleSearchSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    window.location.href = "/homesearchbarmobile";
  };

  handlePropertyClick = (id) => {
    if (!id) return;
    window.location.href = `/listingmobile/${id}`;
  };

  getImageUrl = (image) => {
    if (!image) return "";
    const baseUrl = axios.defaults.baseURL
      ? axios.defaults.baseURL.replace("/api", "")
      : "";
    return `${baseUrl}/uploads/posts/${image}`;
  };

  handleImageError = (e) => {
    e.target.onerror = null;
    e.target.style.display = "none";
    if (e.target.parentElement) {
      e.target.parentElement.classList.add("image-error");
    }
  };

  getRatingData = (item) => {
    const raw = item.ratings !== undefined && item.ratings !== null ? item.ratings : item.rating;
    if (raw === null || raw === undefined || raw === "") {
      return { value: null, label: "New" };
    }
    const numeric = Number(raw);
    if (!Number.isNaN(numeric)) {
      return { value: numeric.toFixed(1), label: null };
    }
    return { value: null, label: String(raw).trim() || "New" };
  };

  renderPropertyCard = (item, index) => {
    const imageUrl = this.getImageUrl(item.image);
    const location = item.location || item.address || "";
    const { value: ratingValue, label: ratingLabel } = this.getRatingData(item);

    return (
      <article
        key={item.id || `property-${index}`}
        className="mobile-property-card"
        role="button"
        tabIndex={0}
        onClick={() => this.handlePropertyClick(item.id)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            this.handlePropertyClick(item.id);
          }
        }}
      >
        <div className="mobile-property-image-wrapper">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={item.title || "Property"}
              className="mobile-property-image"
              loading="lazy"
              onError={this.handleImageError}
            />
          ) : (
            <div className="property-image-placeholder">
              <span>🏠</span>
            </div>
          )}

          {item.isHighlyRecommended && (
            <span className="mobile-recommended-badge">★</span>
          )}

          {ratingValue ? (
            <div className="mobile-rating-badge">
              <svg width="9" height="9" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2 15.09 8.26 22 9.27l-5 4.87L18.18 21 12 17.77 5.82 21 7 14.14 2 9.27l6.91-1.01L12 2z" />
              </svg>
              <span>{ratingValue}</span>
            </div>
          ) : (
            <span className="mobile-new-badge">{ratingLabel}</span>
          )}
        </div>

        <div className="mobile-property-content">
          <h3 className="mobile_property_title">
            {item.title || "Property"}
          </h3>

          {location && (
            <div className="mobile-property-location">
              <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
              <span>{location}</span>
            </div>
          )}

          <div className="mobile-price-section">
            <span className="mobile-price">৳{item.price}</span>
          </div>
        </div>
      </article>
    );
  };

  renderLoading = () => (
    <div className="mobile-search-status">
      <div className="mobile-spinner"></div>
      <h3>Searching properties...</h3>
      <p>Finding the best options for you.</p>
    </div>
  );

  renderEmptyState = () => (
    <div className="not-found-container">
      <div className="not-found-card">
        <div className="not-found-icon">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
          <span className="not-found-icon-badge">
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </span>
        </div>

        <span className="not-found-label">NO RESULTS</span>
        <h2>Nothing found!</h2>
        <p>
          We couldn't find any {this.state.activeTab.toLowerCase()} matching your search.
          Try adjusting your location, dates or filters.
        </p>

        <div className="not-found-tips">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 18h6" />
            <path d="M10 22h4" />
            <path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14" />
          </svg>
          <span>Try checking your spelling or using different keywords.</span>
        </div>

        <button type="button" className="not-found-button" onClick={this.handleSearchSubmit}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
          Change Search
        </button>
      </div>
    </div>
  );

  renderErrorState = () => (
    <div className="not-found-container">
      <div className="not-found-card">
        <div className="not-found-icon not-found-icon--error">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        </div>

        <span className="not-found-label not-found-label--error">SOMETHING WENT WRONG</span>
        <h2>Connection issue</h2>
        <p>{this.state.error}</p>

        <div className="not-found-tips">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 18h6" />
            <path d="M10 22h4" />
            <path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14" />
          </svg>
          <span>Please check your internet connection and try again.</span>
        </div>

        <button type="button" className="not-found-button" onClick={this.fetchSearchData}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
            <path d="M21 3v5h-5" />
            <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
            <path d="M3 21v-5h5" />
          </svg>
          Try Again
        </button>
      </div>
    </div>
  );

  render() {
    const { searchQuery, results, loading, error, notFound, activeTab } = this.state;

    return (
      <div className="search-mobile-container">
        <header className="search-mobile-header">
          <form className="mobile-search-form" onSubmit={this.handleSearchSubmit}>
            <div className="search-input-wrapper">
              <span className="search-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
              </span>

              <input
                type="text"
                className="mobile-search-input"
                value={searchQuery}
                placeholder="Start your search"
                readOnly
                onClick={this.handleSearchSubmit}
              />

              <button type="submit" className="mobile-search-button" aria-label="Search">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="11" cy="11" r="8" />
                  <line x1="21" y1="21" x2="16.65" y2="16.65" />
                </svg>
              </button>
            </div>
          </form>

          <div className="mobile-type-tabs">
            {TABS.map((tab) => (
              <button
                key={tab.key}
                type="button"
                className={`mobile-type-tab ${activeTab === tab.key ? "active" : ""}`}
                onClick={() => this.handleTabChange(tab.key)}
              >
                {tab.icon}
                <span>{tab.label}</span>
              </button>
            ))}
          </div>
        </header>

        <main className="mobile-results-area">
          {loading && this.renderLoading()}
          {!loading && error && this.renderErrorState()}
          {!loading && !error && notFound && this.renderEmptyState()}
          {!loading && !error && !notFound && results.length > 0 && (
            <div className="mobile-results-grid">
              {results.map((item, index) => this.renderPropertyCard(item, index))}
            </div>
          )}
        </main>
      </div>
    );
  }
}

export default SearchResultMobile;
